import { Actionbar, ToolButton } from '@ibinder/common-frontend';
import { smallBoldFont } from 'Shared/Utils/fontUtils';
import styled, { css } from 'styled-components';

export const StyledActionbar = styled(Actionbar)`
  margin-left: -1rem;
  margin-right: -1rem;
  @media (max-width: ${(p) => p.theme.devices.xs}px) {
    margin-left: -0.5rem;
    margin-right: -0.5rem;
  }
  ${({ noTopBorder }) =>
    noTopBorder &&
    css`
      border-top: none;
    `}
`;
export const ActionbarContent = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;
export const ActionBarHeader = styled.span`
  ${({ theme }) => smallBoldFont(theme)}
  padding-left: 1rem;
  width: 100%;
  display: flex;
`;
export const StyledToolButton = styled(ToolButton)`
  ${({ isdelete }) =>
    isdelete &&
    css`
      svg {
        path {
          fill: ${({ theme }) => theme.colors.error};
        }
      }
    `}
  div > input {
    display: none;
  }
`;
export const ItemWrapper = styled.div`
  display: flex;
  align-items: center;
`;
export const ExtraSpace = styled.span`
  @media (max-width: ${(p) => p.theme.devices.xs}px) {
    display: none;
  }
`;
export const DragAndDropInfoText = styled.p`
  font-style: italic;
  color: ${(p) => p.theme.colors.discrete60};
  margin-right: 1rem;
  @media (max-width: ${(p) => p.theme.devices.sm}px) {
    display: none;
  }
`;
export const ToolWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;
